/* eslint-disable import/no-duplicates */
import React from "react";
import format from "date-fns/format";
import ptBR from "date-fns/locale/pt-BR";
import environments from "../../../../../environments";
import { ICemeteryDeceasedResponse } from "../../../../../shared/providers/cemetery/entities/deceased-cemetery.interface";
import { ICemeteryResponse } from "../../../../../shared/providers/cemetery/entities/cemetery.interface";

export interface Props {
    cemeteryInfo: ICemeteryResponse;
    idDeceased: string | undefined;
}

export const IpirangaBodyAutorizacaoAberturaTumulo: React.FC<Props> = ({
    cemeteryInfo,
    idDeceased,
}) => {
    const formattedData = format(new Date(), "dd 'de' MMMM 'de' yyyy", {
        locale: ptBR,
    });

    let currentDeceased = {} as ICemeteryDeceasedResponse | undefined;

    if (cemeteryInfo && cemeteryInfo.deceased && idDeceased) {
        currentDeceased = cemeteryInfo.deceased.find(
            (d) => d.id === parseInt(idDeceased, 10)
        );
    }

    return (
        <div className="w-full text-justify">
            <div className="w-full flex justify-center">
                <h4 className="font-bold">DECLARAÇÃO DE RESPONSABILIDADE</h4>
            </div>
            <br />
            <div>
                <p>
                    EU, <strong>{cemeteryInfo.propnome}</strong> portador(a) do
                    CPF Nº <strong>{cemeteryInfo.propdocumento}</strong>,
                    residente no logradouro{" "}
                    <strong>{cemeteryInfo.logradouronome}</strong>, Nº{" "}
                    <strong>{cemeteryInfo.logradouronumero}</strong>, bairro{" "}
                    <strong>{cemeteryInfo.bairronome}</strong>, cidade{" "}
                    <strong>{cemeteryInfo.cidade}</strong> telefone:{" "}
                    <strong>{cemeteryInfo.telefone}</strong>,{" "}
                    <strong>{cemeteryInfo?.grave?.especie}</strong> do JAZIGO
                    localizado na quadra{" "}
                    <strong>{cemeteryInfo.grave?.quadra}</strong>, lote{" "}
                    <strong>{cemeteryInfo.grave?.lote}</strong>, controle{" "}
                    <strong>{cemeteryInfo.grave?.controle}</strong>, no
                    cemitério Municipal de Ipiranga, onde está sepultado (a){" "}
                    <strong>{currentDeceased?.nome}</strong>, e venho pelo
                    presente declarar e me responsabilizar que{" "}
                    <strong>AUTORIZO A ABERTURA DO JAZIGO</strong> acima, para
                    realização do sepultamento.
                </p>
            </div>
            <br />
            <div className="w-full flex justify-center">
                <p>Por ser verdade firmo o presente.</p>
            </div>
            <br />
            <br />
            <div className="w-full flex justify-center">
                <h5 className="font-bold">
                    ______________________________________________________
                </h5>
            </div>
            <div className="w-full flex justify-center">
                Assinatura do responsável do jazigo
            </div>
            <br />
            <br />
            <br />
            <div className="w-full flex justify-center">
                <p>
                    {environments.webgeo.cemiterio?.municipio}, {formattedData}.
                </p>
            </div>
            <br />
            <br />
            <br />
            <br />
            <br />
            <footer>
                <strong>Observação:</strong> O subscritor, sob compromisso de
                honra e estando consciente de incorrer em eventual
                responsabilidade penal caso preste falsas declarações, declara
                que os dados constantes da presente declaração correspondem à
                verdade e sobre eles assume inteira responsabilidade nos termos
                legais. Deste modo, declaro que assumo toda a responsabilidade,
                sem que tal importe qualquer indenização ou encargo monetário
                para a Junta de prefeitura municipal de Ipiranga, sobre qualquer
                ação intentada por um familiar.
            </footer>
        </div>
    );
};
